
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Proyecto Gemini',
	'appExit': 'Ir a la página de bienvenida',


	'widgetsListLabel': 'Lista de widgets. Seleccione un widget y pulse Intro para añadirlo.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Actualizada',
	'dirty': 'No actualizada',
	'conflict': 'Conflicto al guardar la vista',
	'error': 'Problema al guardar la vista',
	'failure': 'No se puede contactar con el servidor',
	'saveFailed': 'No se puede guardar la vista',

	'wa_insync': 'Guardada',
	'wa_conflict': 'Conflicto al guardar la vista',
	'wa_error': 'No se puede guardar la vista',
	'wa_failure': 'No se puede contactar con el servidor',

	// Menu Labels
	'changeDisplay': 'Cambiar visualización',
	'changeToColumnChart': 'Cambiar por gráfico de columnas',
	'changeToBubbleChart': 'Cambiar por gráfico de burbujas',
	'toggleMoveHandles': 'Alternar puntos de arrastre para mover',
	'undo': 'Deshacer',
	'redo': 'Rehacer',
	'mode': 'Cambiar el modo',

	'untitled': 'Sin título',
	'remove': 'Eliminar',
	'editTitle': 'Editar el título',
	'edit': 'Editar',
	'done': 'Listo',

	// Data tray
	'dataTrayHandleOpenLabel': 'Abrir bandeja de datos',
	'dataTrayHandleCloseLabel': 'Cerrar bandeja de datos',

	// Dialogs
	'dlg_loading': 'Cargando...',
	'dlg_ok': 'Aceptar',
	'dlg_create': 'Crear',
	'dlg_cancel': 'Cancelar',
	'dlg_close': 'Cerrar',
	'dlg_update': 'Actualizar',
	'dlg_renameBoardTitle': 'Cambiar nombre de este objeto',
	'dlg_renameDatasetTitle': 'Cambiar nombre de este conjunto de datos',
	'dlg_renameSceneTitle': 'Cambiar nombre de esta escena',
	'dlg_NameLabel': 'Nombre:',
	'dlg_NewNameLabel': 'Nuevo nombre:',
	'dlg_DefaultNameWithDataSet': 'Vista %{name}',
	'dlg_ShareTitle': 'Compartir contenido',
	'dlg_UnshareTitle': 'Eliminar compartición de contenido',
	'dlg_ShareUser': 'ID de usuario:',
	'dlg_NewColumnLabel': 'Nombre del nuevo cálculo',

	'dlg_new': 'Nuevo...',
	'dlg_open': 'Abrir...',
	'dlg_makeACopy': 'Hacer una copia',
	'dlg_rename': 'Cambiar nombre...',
	'dlg_moreToCome': 'Hay más acciones...',

	'dlg_use': 'Usar',

	'dlg_RelinkDatasetTitle': 'Sustituir el conjunto de datos \'%{datasetName}\' por...',

	'open_error': 'Se ha producido un problema al abrir la vista.',

	// Delete Board
	'del_dialogTitle': 'Confirmar supresión',
	'del_itemMsg': '¿Está seguro de que desea suprimir \'%{name}\'?',
	'del_itemsMsg': '¿Está seguro de que desea suprimir %{count} elementos?',
	'del_deleteErr': 'No se ha podido suprimir \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'ascendente',
	'dlg_descending': 'descendente',
	'dlg_custom': 'personalizado',
	'dlg_none': 'ninguno',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Buscar',

	'searchHint': 'Realizar una búsqueda en todos sus datos',
	'clearSearchResult': 'Borrar resultados de búsqueda',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': 'Círculo',
	'shapesHexagon': 'Hexágono',
	'shapesLine': 'Línea',
	'shapesOctagon': 'Octágono',
	'shapesPentagon': 'Pentágono',
	'shapesSquare': 'Cuadrado',
	'shapesTriangle': 'Triángulo',
	'shapesDiamond': 'Rombo',
	'shapesTitle': 'Propiedades de forma', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': 'Cuadrado redondeado',
	'shapesStar': 'Estrella',
	'shapesChevron': 'Comillas angulares',
	'shapesBadge_ribbon': 'Cinta de identificador',
	'shapesBadge': 'Identificador',
	'shapesHeart': 'Corazón',
	'shapesExclamation': 'Signo de exclamación',
	'shapesTrendingup': 'Tendencia al alza',
	'shapesTrendingdown': 'Tendencia a la baja',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Personas',
	'shapesFemale': 'Femenino',
	'shapesHappyface': 'Cara sonriente',
	'shapesMale': 'Masculino',
	'shapesMan': 'Hombre',
	'shapesNeutralface': 'Cara neutra',
	'shapesSadface': 'Cara triste',
	'shapesShakehands': 'Estrechar la mano',
	'shapesThumbsdown': 'Pulgar abajo',
	'shapesThumbsup': 'Pulgar arriba',
	'shapesWoman': 'Mujer',

	// Weather and places
	'shapesPlacesWeatherCat': 'Lugares y meteorología',
	'shapesCity': 'Población',
	'shapesCloud': 'Nube',
	'shapesEducation': 'Formación',
	'shapesGovernment': 'Administraciones públicas',
	'shapesHalfcloud': 'Media nube',
	'shapesHouse': 'Casa',
	'shapesMoon': 'Luna',
	'shapesRain': 'Lluvia',
	'shapesSunny': 'Soleado',

	//Vehicles
	'shapesVehiclesCat': 'Vehículos',
	'shapesAirplane': 'Avión',
	'shapesCar': 'Automóvil',
	'shapesShip': 'Barco',
	'shapesShoppingcart': 'Carrito de la compra',
	'shapesTrain': 'Tren',
	'shapesTruck': 'Camión',

	//Objects
	'shapesObjectsCat': 'Objetos',
	'shapesBook': 'Libro',
	'shapesBriefcase': 'Maletín',
	'shapesCalendar': 'Calendario',
	'shapesCheck': 'Cheque',
	'shapesClock': 'Reloj',
	'shapesDesktop': 'Escritorio',
	'shapesDocument': 'Documento',

	'shapesFood': 'Comida',
	'shapesGear': 'Engranaje',
	'shapesHealth': 'Salud',

	'shapesIdea': 'Idea',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': 'Billete',
	'shapesMoney_coin': 'Moneda',
	'shapesPiggybank': 'Hucha',
	'shapesStackofpaper': 'Pila de papeles',
	'shapesStickynote1': 'Nota adhesiva 1',
	'shapesStickynote2': 'Nota adhesiva 2',
	'shapesTarget': 'Diana',
	'shapesTool': 'Herramienta',

	'shapesUmbrella': 'Paraguas',

	'shapesBrain': 'Cerebro',
	'shapesSkull': 'Calavera',
	'shapesEye': 'Ojo',

	// Arrows shapes
	'shapesArrowsCat': 'Flechas',
	'shapesRightArrow': 'Flecha derecha',
	'shapesLeftArrow': 'Flecha izquierda',
	'shapesDoubleArrow': 'Flecha doble',
	'shapesCurvedArrow': 'Flecha curva',

	// Callouts shapes
	'shapesCalloutsCat': 'Rótulos',
	'shapesRectCallout': 'Comentario emergente',

	// Images
	'imagesCat': 'Imágenes',
	'imageWidgetTitle': 'Widget de imagen',
	'imgUrl': 'URL de imagen',
	'noImgSelected': 'No hay ninguna imagen seleccionada',
	'enterImgUrl': 'Especifique el URL de la imagen aquí',
	'imgPasteLink': 'Pegue el URL y pulse Intro para guardarlo.',
	'imgResizeToFit': 'Cambiar tamaño para ajustar al tamaño de la imagen',
	'imgHeight': 'Altura:',
	'imgWidth': 'Anchura:',
	'imgTransparency': 'Transparencia:',
	'imgMissingUrl': 'Falta el URL de imagen.',
	'imgUrlValidationError': 'El URL de imagen no es válido.',
	'imgUrlInvalidDomainError': 'El URL de imagen apunta a un dominio que no ha sido aprobado por el administrador. Los dominios aprobados por el administrador son "%{domains}".',
	'notPositiveNumberError': 'Solo valores positivos',

	// line shape
	'propStrokeWidth': 'Grosor de línea',
	'propStrokeDashArray': 'Estilo de línea',
	'propStrokeSolidline': 'Línea sólida',
	'propStrokeLineCap': 'Límite de línea',
	'propStrokeLineCapButt': 'Extremo',
	'propStrokeLineCapRound': 'Redondeado',
	'propStrokeLineCapSquare': 'Cuadrado',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Reproducir',
	'dataPlayerValueListLabel': 'Valores del reproductor de datos',
	// Text Widget
	'textWidgetTitle': 'Widget de texto',
	'textStyle': 'Estilos',
	'textStyleDescription': 'Estilos de texto preformateados',
	'textTitleStyle': 'Título',
	'textTitleSmallStyle': 'Título pequeño',
	'textSubtitleStyle': 'Subtítulo',
	'textBodyStyle': 'Cuerpo',
	'textBodySmallStyle': 'Cuerpo pequeño',
	'textCaptionStyle': 'Título',
	'textQuoteStyle': 'Cita',
	'textQuoteSmallStyle': 'Cita pequeña',
	'textResponsiveStyle': 'Tamaño automático',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Fina',
	'textFontFamilySubClassThin': 'Delgada',
	'textFontFamilySubClassThinItalic': 'Cursiva delgada',
	'textFontFamilySubClassExtraLight': 'Extra Light',
	'textFontFamilySubClassExtraLightItalic': 'Extra clara cursiva',
	'textFontFamilySubClassLight': 'Claro',
	'textFontFamilySubClassLightItalic': 'Cursiva clara',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Cursiva regular',
	'textFontFamilySubClassItalic': 'Cursiva',
	'textFontFamilySubClassMedium': 'Medio',
	'textFontFamilySubClassMediumItalic': 'Cursiva mediana',
	'textFontFamilySubClassHeavy': 'Intensa',
	'textFontFamilySubClassHeavyItalic': 'Cursiva intensa',
	'textFontFamilySubClassDemiBold': 'Semi-negrita',
	'textFontFamilySubClassDemiBoldItalic': 'Semi-negrita cursiva',
	'textFontFamilySubClassBold': 'Negrita',
	'textFontFamilySubClassBoldItalic': 'Negrita cursiva',
	'textFontFamilySubClassExtraBold': 'Extra negrita',
	'textFontFamilySubClassExtraBoldItalic': 'Extra negrita cursiva',
	'textFontFamilySubClassBlack': 'Negro',
	'textFontFamilySubClassBlackItalic': 'Negra cursiva',
	'textFontFamilySubClassStencil': 'Esténcil',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': 'Fuente de tamaño automático',
	'responsiveCoachmarkContents': 'El tamaño de la fuente cambia cuando se cambia el tamaño de este tipo de texto. Puede establecer el tamaño de fuente en las propiedades del texto.',

	'propText': 'Detalles de texto', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'Propiedades del texto', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'Tamaño de fuente',
	'textFontFamily': 'Familia de fuentes',
	'textFontWeight': 'Peso de fuente', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': 'Color',
	'textLineHeight': 'Altura de línea',
	'textIndentation': 'Sangría',
	'textIncreaseIndentation': 'Aumentar sangrado',
	'textDecreaseIndentation': 'Reducir sangrado',
	'textInnerMargins': 'Márgenes interiores (px)',

	// Widget Properties
	'propImageLink': 'Enlace de la imagen',
	'propMissingURL': 'Entrar URL',
	'propImgTop': 'Propiedades de la imagen', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': 'Propiedades generales', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': 'General', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': 'Color de relleno', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'Color del texto', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': 'Color del borde',
	'propBorderRadius': 'Radio de esquina (px)',
	'propShowBorderInPreview': 'Mostrar el borde seleccionado en la vista previa',
	'propMaintainAxisScales': 'Mantener escala de eje',
	'propShowItemLabel': 'Mostrar la etiqueta de elemento',
	'propHideLegend': 'Ocultar la leyenda',
	'propColorPalette': 'Paleta',
	'propLegendPosition': 'Posición de la leyenda',
	'propHideAxisTitleLabels': 'Ocultar títulos de los ejes',
	'propLineColor': 'Color de línea',
	'propBubbleColor': 'Color de burbuja',
	'propInterpolation': 'Líneas suavizadas',
	'propElementColor': 'Color de elemento de visualización',
	'propSymbolShape': 'Forma del símbolo',
	'propHeatScalePalette': 'Orden de colores',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Los colores más oscuros representan los valores más bajos.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Los colores más oscuros representan los valores más altos.',
	'propImageDetails': 'Detalles de la imagen', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Detalles de la página web', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'Detalles del soporte multimedia', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'Escriba el URL y pulse Intro.',

	//Layout Properties
	'sectionName_positionAndStyle': 'Posición y estilo',
	'propPositionLabel': 'Posición', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'Posición X (%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Posición Y (%{unit})',
	'propResizeLabel': 'Tamaño', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': 'Anchura',
	'propResizeWidth': 'Anchura (%{unit})',
	'propResizeHeight_v1': 'Altura',
	'propResizeHeight': 'Altura (%{unit})',
	'propRotateLabel_v1': 'Rotar',
	'propRotateLabel': 'Rotar (°)',
	'propRotateAngle': 'Ángulo', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Cantidad de iconos',
	'propScaleDescription': 'Seleccione la cantidad de iconos',
	'propScaleFew': 'Baja',
	'propScaleDefault': 'Valor predeterminado',
	'propScaleMany': 'Alta',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'El valor debe ser numérico',

	'mediaAriaLabel': 'entrada de url',
	'dropdownAriaLabel' : 'Desplegable',
	'ariaGroupLabel': 'Categoría de lista desplegable: %{cateoryLabel} elemento %{itemLabel}. Pulse la tecla ABAJO para expandir. Pulse las teclas ARRIBA y ABAJO para desplazarse o pulse la tecla ESCAPE para contraer.',
	'colorNoFillLabel': 'Sin relleno',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Última renovación: Hace %{timeInterval}',
	'widgetTimer': 'Temporizador del widget',

	// Theme colors
	'transparent': 'Sin color',
	'white': 'Blanco',
	'lightGrey': 'Gris claro',
	'grey': 'Gris',
	'darkGrey': 'Gris oscuro',
	'black': 'Negro',
	'lightBlue': 'Azul claro',
	'blue': 'Azul',
	'darkBlue': 'Azul oscuro',
	'yellow': 'Amarillo',
	'orange': 'Naranja',
	'lime': 'Lima',
	'green': 'Verde',
	'peach': 'Melocotón',
	'red': 'Rojo',
	'violet': 'Violeta',
	'aqua': 'Aguamarina',
	'purple': 'Púrpura',
	'plum': 'ciruela',
	'gray10': 'Gris 10',
	'gray20': 'Gris 20',
	'gray30': 'Gris 30',
	'gray50': 'Gris 50',
	'gray60': 'Gris 60',
	'gray70': 'Gris 70',
	'gray80': 'Gris 80',
	'gray90': 'Gris 90',
	'gray100': 'Gris 100',
	'blue50': 'Azul 50',
	'blue60': 'Azul 60',
	'blue70': 'Azul 70',
	'green40': 'Verde 40',
	'green50': 'Verde 50',
	'red50': 'Rojo 50',
	'red60': 'Rojo 60',


	//Theme Palette Labels
	'themeLabel': 'Tema',
	'paletteLabel': 'Paleta de IBM %{number}',
	'heatPaletteLabel': 'Paleta de uso de crítico de IBM %{number}',
	'conditionalPaletteLabel': 'Paleta condicional de IBM %{number}',
	'carbonPaletteXLight': 'Carbon X claro',
	'carbonPaletteXDark': 'Carbon X oscuro',
	'carbonPalettePurple': 'Púrpura',
	'carbonPaletteTeal': 'Verde azulado',
	'carbonPaletteCyan': 'Cian',
	'carbonPaletteMagenta': 'Magenta',
	'carbonPalettePurpleTeal': 'Verde púrpura',
	'carbonPaletteCyanMagenta': 'Cian Magenta',
	'carbonPaletteGreenRed': 'Rojo verde',
	'carbonPaletteGreenYellowRed': 'Rojo amarillo verde',
	'carbonPalettePurpleTealConvergent': 'Verde púrpura convergente',
	'carbonPaletteCyanMagentaConvergent': 'Cian Magenta convergente',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'Paleta luminosa de IBM',
	'userPaletteColor_defaultTheme': 'Paleta predeterminada de IBM',
	'userPaletteColor_darkTheme': 'Paleta oscura de IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Color de fondo',
	'propLayoutPositioning': 'Posicionamiento de diseño',
	'propLayoutRelative': 'Relativo',
	'propLayoutAbsolute': 'Absoluto',
	'propLayoutPositioningCoachmarkTitle': 'Seleccione un estilo de diseño',
	'propLayoutPositioningCoachmarkContent': 'En un diseño relativo, el tamaño y la posición de los widgtes se ajustan a la pantalla. Los widgets de un diseño absoluto aparecen en la vista con el tamaño y ubicación exactos que ha ajustado, independientemente del tamaño de la pantalla.',
	'gridText': 'Mostrar cuadrícula',
	'snapText': 'Ajustar a cuadrícula',
	'snapObjectsText': 'Ajustar a objetos',
	'fitPageText': 'Ajustar página',
	'gridLabel': 'Cuadrícula',
	'heightUnit': 'h',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Tamaño de página',
	'propPageSizePresetAriaLabel': 'Tamaño de página preestablecido',
	'propPageSizePreset_v1': 'Predefinir',
	'propPageSizePreset': 'Tamaño de página',
	'propPageSizePresetCustom': 'Personalizado',
	'propPageSizePreset16x9': 'Pantalla 16:9',
	'propPageSizePreset4x3': 'Pantalla 4:3',
	'propPageSizePresetInfographic': 'Infografía',
	'propPageSizeWidth_v1': 'Anchura',
	'propPageSizeWidth': 'Anchura (px)',
	'propPageSizeHeight_v1': 'Altura',
	'propPageSizeHeight': 'Altura (px)',
	'propPageSizeWidthAriaLabel': 'Ancho de tamaño de página',
	'propPageSizeHeightAriaLabel': 'Altura de tamaño de página',
	'propPageSizeAdjustedMessage': 'El tamaño de la pantalla se ha aumentado debido a que su entrada estaba por debajo del mínimo o no se ajustaría a su panel de control.',
	'propTabShow': 'Mostrar pestañas',
	'propShowTabsInPreview': 'Mostrar pestañas en la vista previa',
	'multilingualDashboardsLabel': 'Idiomas',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Predeterminado ',
	'multilingualDashboardsAddLinkText': 'Añadir otro idioma',
	'multilingualDashboardsSelect': 'Seleccionar',
	'multilingualDashboardsButtonLabel': 'Añadir',
	'multilingualDashboardTranslationMode': 'Ahora está en modo de traducción (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Listo',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} traducciones restantes',
	'multilingualDashboardRemainingString': '1 traducción restante',
	'multilingualDashboardsSetDefault': 'Establecer idioma predeterminado',
	'multilingualDashboardIconMore': 'Más acciones para el idioma %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Área traducible',
	'multilingualDeleteTitle': 'Suprimir idioma',
	'multilingualDeleteLanguageWarning': '¿Está seguro de que desea suprimir el idioma \'%{language}\'?',
	'multilingualSelectLanguage': 'Seleccionar un idioma',
	'confirmLayoutStyleUpgradeTitle': 'Aplicar a todas las pestañas',
	'confirmLayoutStyleUpgrade': '¿Aplicar este estilo de diseño a todas las pestañas del panel de control?',
	'defaultBackgroundColorLabel': 'Valor predeterminado',

	//Tabs
	'tabDeleteDialogPrimaryButton': 'Suprimir',
	'tabDeleteDialogTitle': '¿Suprimir esta pestaña?',
	'tabDeleteDialogMessage': 'También se suprimirá todo el contenido de esta pestaña.',

	// Vis widget
	'propVisTypeReturn': 'Tipos de visualización',
	'propVisDetails': 'Detalles',

	// Alignment picker
	'propAlignPickTop': 'Alinear arriba',
	'propAlignPickRight': 'Alinear a la derecha',
	'propAlignPickBottom': 'Alinear abajo',
	'propAlignPickLeft': 'Alinear a la izquierda',
	'propAlignPickCenter': 'Alinear al centro',
	'propAlignPickMiddle': 'Alinear en el centro',
	'propAlignPicker': 'Alineación horizontal',
	'propVerticalAlignPicker': 'Alineación vertical',

	// Toolbar picker
	'propToolbarPickBold': 'Negrita',
	'propToolbarPickUnderline': 'Subrayado',
	'propToolbarPickItalic': 'Cursiva',
	'propToolbarPickJustifyLeft': 'Alinear a la izquierda',
	'propToolbarPickJustifyCenter': 'Alinear al centro',
	'propToolbarPickJustifyRight': 'Alinear a la derecha',
	'propToolbarPickJustify': 'Justificar',

	'propList': 'Lista',
	'propOrderedList': 'Lista ordenada',
	'propUnorderedList': 'Lista no ordenada',

	// Symbol shapes
	'propCircle': 'Círculo',
	'propTriangle': 'Triángulo',
	'propSquare': 'Cuadrado',
	'propRect': 'Rectángulo',
	'propStar': 'Estrella',
	'propCross': 'Superpuesto',
	'propPlus': 'Más',
	'propPoly': 'Polígono',


	// True and false selection
	'propTrue': 'Verdadero',
	'propFalse': 'Falso',

	// Position selection
	'propLeft': 'Izquierda',
	'propRight': 'Derecha',
	'propTop': 'Superior',
	'propBottom': 'Abajo',

	// Interpolation options
	'propSmooth': 'Suavizado',
	'propStraight': 'Recta',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Lista', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Mover a la izquierda', // screen reader
	'srWidgetMoveUp': 'Subir', // screen reader
	'srWidgetMoveRight': 'Mover a la derecha', // screen reader
	'srWidgetMoveDown': 'Bajar', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Aumentar el tamaño proporcionalmente', // screen reader
	'srWidgetResizeSmaller': 'Reducir el tamaño proporcionalmente', // screen reader
	'srWidgetResizeBiggerV': 'Aumentar el tamaño verticalmente', // screen reader
	'srWidgetResizeSmallerV': 'Reducir el tamaño verticalmente', // screen reader
	'srWidgetResizeBiggerH': 'Aumentar el tamaño horizontalmente', // screen reader
	'srWidgetResizeSmallerH': 'Reducir el tamaño horizontalmente', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Girar hacia la derecha', // screen reader
	'srWidgetRotateCCW': 'Girar hacia la izquierda', // screen reader

	// Recommended types
	'visChange': 'Cambiar visualización',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualización',
	'chartLabel': 'Diagrama %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pulse F12 para navegar por el widget',
	'f10KeyDescription': 'Pulse F10 para lanzar la vista de enfoque de widget',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} con el valor %{value}',

	'shapeColorLabel': 'Color de forma',
	'showLegendLabel': 'Mostrar leyenda',

	//Webpage
	'webpageWidgetTitle': 'Widget de página web',
	'webpagePasteLink': 'Pegar el URL y pulsar la tecla Intro para guardarlo.',
	'propWebpageLink': 'URL de la página web',
	'propWebpageTitle': 'Título de la página web',
	'propWebpageTitleDescription': 'Título de la página web',
	'webpageUrl': 'URL de página web ',
	'noWebpageSelected': 'No se ha seleccionado ninguna página web',
	'enterWebpageUrl': 'Especifique el URL de la página web aquí',
	'propWebpageTop': 'Propiedades de la página web', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Falta el URL de página web.',
	'webpageUrlValidationError': 'El URL de página web no es válido.',
	'webpageHttpValidationError': 'Se debe acceder a la página web mediante un enlace HTTPS.',
	'webpageInvalidDomainError': 'El URL de página web apunta a un dominio que no ha sido aprobado por el administrador. Los dominios aprobados por el administrador son "%{domains}".',

	//VizState
	'vzErrorLoading': 'No se puede cargar la visualización',
	'vzErrorLoadingMissingData': 'No se puede cargar la visualización; faltan datos de contexto',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Widget multimedia',
	'mediaPasteLink': 'Pegar el URL y pulsar la tecla Intro para guardarlo.',
	'mediaUrl': 'URL de soportes',
	'noMediaSelected': 'No hay ningún soporte seleccionado',
	'enterMediaUrl': 'Especifique el URL del soporte aquí',
	'videoHeight': 'Altura:',
	'videoWidth': 'Anchura:',
	'propMediaLink': 'Enlace multimedia',
	'propMediaTitle': 'Título del soporte multimedia',
	'propMediaTitleDescription': 'Título del soporte multimedia',
	'propMediaTop': 'Propiedades del soporte multimedia', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'Falta el URL del enlace multimedia.',
	'mediaUrlValidationError': 'El URL del archivo multimedia no es válido.',
	'mediaUnknownValidationError': 'Este tipo de soporte multimedia no está admitido.',
	'mediaHttpValidationError': 'Se debe acceder al archivo multimedia utilizando un enlace HTTPS.',
	'mediaInvalidDomainError': 'El URL de medios apunta a un dominio que no ha sido aprobado por el administrador. Los dominios aprobados por el administrador son "%{domains}".',

	// Properties pane
	'commonPropertiesLabel': 'Propiedades', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'Conjunto de datos',
	'dataViewsLabel': 'Ver',
	'columnQuality': 'Calidad de los datos',
	'columnProperties': 'Propiedades de los datos',

	'dataQuality': 'Calidad de los datos',
	'dataQualityRowCount': 'Número de filas',
	'dataQualityDistribution': 'Distribución',
	'dataRowLabel': 'Datos',

	// Modelling UI
	'typeColumn': 'Tipo',
	'modellingColumnType': 'Tipo',
	'modellingColumnAggregation': 'Agregación',
	'modellingColumnUsage': 'Uso',
	'modellingColumnSort': 'Ordenar',
	'modellingColumnFormat': 'Formato',
	'modellingColumnCategory': 'Categoría',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Cargando...',

	'modellingProcessing': 'Procesando...',
	'modellingImport': 'Importar',
	'modellingReimport': 'Volver a importar',
	'modellingDatasourceTitle': 'Origen de datos',
	'modellingImportStartedTitle': 'La importación ha comenzado',
	'modellingImportStartedText': 'La importación de datos puede tardar algún tiempo. (Puede crear una vista mientras se importan los datos). ',
	'importDatasourceTitle': 'Conexiones',
	'dropHere': 'Soltar aquí para crear un nuevo origen de datos...',
	'browseButton': 'Examinar',
	'errorNoData': 'No hay datos para procesar.',
	'errorNoFile': 'No hay archivos para cargar.',
	'errorUploadFailed': 'No se puede cargar.',
	'uploadSucceessful': 'Carga efectuada correctamente',
	'del_datasourceTitle': 'Suprimir conjunto de datos',
	'del_datasourceMsg': '¿Está seguro de que desea suprimir \'%{name}\'?',
	'modellingFileUpdate': 'Actualizar',
	'modellingFileUpdateTitle': 'Actualizar conjunto de datos',
	'modellingFileUpdateDescription': '¿Desea actualizar \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Actualizando \'%{name}\'',
	'modellingUpdateStartedTitle': 'La actualización de la importación ha comenzado',
	'modellingUpdateStartedText': 'La actualización de los datos puede tardar algún tiempo. (Puede crear una vista mientras se actualizan los datos). ',
	'modellingErrorImportUploadNoFile': 'No hay ningún archivo para cargar.',
	'modellingErrorImportUploadFailed': 'No se puede cargar.',
	'modellingErrorImportUploadInvalidType': 'El tipo de archivo no es válido.',
	'modellingErrorImportUploadTableFailed': 'No se pueden obtener las tablas.',
	'modellingIntentResultsTitle': 'Seleccionar el conjunto de datos propuesto que se utilizará',
	'modellingColumnViewRelationships': 'Ver tablas relacionadas',
	'modellingTableRelatedTables': 'Tablas relacionadas con \'%{name}\'',
	'modellingTable': '%{name} - Tabla',
	'modellingColumnIncludedInDataSet': 'Añadido',
	'modellingDataSet': 'Conjunto de datos',
	'modellingViewInDataSet': 'Ver en conjunto de datos',
	'modellingViewRelatedTables': 'Ver relacionadas',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'No se han encontrado tablas relacionadas',

	'modellingValidatingDataset': 'Validando...',
	'datasetFinishedRefreshing': 'Se ha renovado el conjunto de datos %{datasetName}. ',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Resolver ruta de unión:',
	'modellingJoinColumns': 'Definir una ruta de unión para la tabla: %{name}',
	'modellingJoinToTable': 'Unir a tabla: %{name}',

	// Data Quality
	'excluded': 'Excluidos',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filtro',
	'modellingColumnSortNone': 'Borrar la ordenación',
	'modellingColumnSortAsc': 'Orden ascendente',
	'modellingColumnSortDesc': 'Orden descendente',
	'modellingColumnRemove': 'Eliminar esta columna',

	// Import File Browser
	'dropboxPageTitle': 'Nueva conexión de Dropbox',
	'sizeColumn': 'Tamaño',

	//Modelling Column Property Values
	'dataType_string': 'Cadena',
	'dataType_date': 'Fecha',
	'dataType_integer': 'Entero',
	'dataType_double': 'Doble',
	'dataType_float': 'Float',
	'dataType_boolean': 'Booleano',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Recuento',
	'defaultAggregation_countdistinct': 'Recuento distinto',
	'defaultAggregation_max': 'Máximo',
	'defaultAggregation_min': 'Mínimo',
	'defaultAggregation_avg': 'Promedio',
	'defaultAggregation_sum': 'Suma',
	'defaultAggregation_auto': 'Automático (%{aggregationType})',

	'type_fact': 'Hecho',
	'type_attribute': 'Atributo',

	'defaultSort_none': 'No ordenar',
	'defaultSort_asc': 'Orden ascendente',
	'defaultSort_desc': 'Orden descendente',

	'category_none': 'Ninguno',
	'category_location': 'Ubicación',
	'category_monetary': 'Monetario',
	'category_time': 'Hora',

	// Root menu
	'rootMenuTitle': 'Menú principal',

	'errorMessageTitle': 'Error',
	'errorMessageDetails': 'Detalles: ',
	'errorMessageTitleAssetAlreadyExists': 'El activo ya existe',

	'defaultTabTitle': 'Pestaña %{index}',
	'tabAddBtnTitle': 'Añadir una nueva pestaña',
	'defaultInfographicTitle': 'Infografía',

	'unsupportedConditionalFormattingEncountered': 'El formato condicional ya no se aplica a algunas columnas.',


	// Homepage View
	'nameColumn': 'Nombre',
	'creatorColumn': 'Creado por',
	'creationDateColumn': 'Fecha de creación',
	'versionColumn': 'Versión',
	'modifiedColumn': 'Última modificación',

	'filterBy': 'Filtrar elementos',
	'allFilter': 'Todos los elementos',
	'createdByMeFilter': 'Creados por mí',
	'sharedWithMeFilter': 'Compartidos conmigo',
	'favoritesFilter': 'Mis favoritos',
	'recentsFilter': 'Añadidos recientemente',
	'sortBy': 'Ordenar por',

	// Sort Menu
	'sortModified': 'Modificado',
	'sortUpdated': 'Actualizado',
	'sortName': 'Nombre',

	'viewAs': 'Ver como',
	'thumbnailsView': 'Ver como miniaturas',
	'listView': 'Ver como lista',
	'createMenu': 'Crear',
	'newAppItem': 'Panel de control',
	'newDataSet': 'Conjunto de datos',

	'menuSelectionState_a11y': 'Selector de "%{item}" establecido en "%{selectedItem}"',

	'unableToShareItem': 'No se puede compartir el elemento "%{item}".',
	'toastFetchingContent': 'Obteniendo más contenido...',
	'unableToGetData': 'No se puede obtener el contenido.',
	'unableToFavorite': 'No se puede cambiar el estado de los favoritos.',
	'hpErrorMissingRequiredOptions': 'Faltan opciones de inicialización obligatorias',
	'unableToOpenBoard': 'No se ha podido abrir "%{name}".',
	'unableToDuplicateBoard': 'No se ha podido duplicar "%{name}".',
	'unableToCreateBoard': 'No se ha podido crear "%{name}".',
	'unableToCreateBoardNameConflict': 'Ya existe un activo con el mismo nombre.',

	// DataSet Detail View
	'status': 'Estado',
	'numberOfRows': 'Filas',
	'importWarnings': 'Avisos',
	'lineNumbers': 'Líneas',
	'excerptFromSource': 'Fragmentos',
	'reason': 'Motivo',
	'numberOfRowsDropped': 'filas soltadas',
	'oneRowDropped': 'Se ha soltado 1 fila',

	// Type Menu
	'typeMenuLabel': 'Tipo',
	'dashboardsLabel': 'Paneles de control',
	'datasetsLabel': 'Conjuntos de datos',
	'storiesLabel': 'Historias',
	'allLabel': 'Todos los tipos',

	// Board Page View App Bar
	'datasets': 'Conjuntos de datos',
	'settings': 'Propiedades',
	'add': 'Añadir',
	'widgets': 'Widgets',
	'dashboardProperties': 'Propiedades del panel de control',
	'searchPanel' : 'Buscar',
	'pins': 'Recopilación',
	'pinsOld': 'Mis chinchetas',
	'pinsDateFilterHeading' : 'Fecha anclada',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} chincheta |||| %{smart_count} chinchetas',
	'pinSearch': 'Buscar',
	'pinSearchOld': 'Buscar chinchetas',
	'pinListView': 'Vista de lista',
	'pinIconView': 'Vista de icono',
	'pinRemove': 'Eliminar',
	'pinCreate': 'Crear',
	'pinDeleteError': 'No podemos suprimir uno o varios activos de la recopilación. Vuelva a intentarlo más tarde.',
	'pinDeleteErrorOld': 'No podemos suprimir una o varias chinchetas. Vuelva a intentarlo más tarde.',
	'pinRetrieveError': 'No se pueden recuperar una o varias chinchetas. Vuelva a intentarlo más tarde.',
	'NoPinsCollected': 'No hay visualizaciones ancladas',
	'pinDeletedToast': 'Se ha eliminado la chincheta',
	'pinRenamedToast': 'Se ha renombrado la chincheta',
	'pinAddedToast': 'La chincheta se ha añadido correctamente a Mis chinchetas',
	'pinningToast': 'Procesando chincheta...',
	'pinDateFilter': 'Filtrar fecha',
	'pinDateFilterAll': 'Todo',
	'pinDateFilterToday': 'Hoy',
	'pinDateFilterYesterday': 'Ayer',
	'pinDateFilterPastWeek': 'Semana pasada',
	'pinDateFilterPastMonth': 'Mes pasado',
	'pinDateFilterEarlier': 'Anterior',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Editar título',
	'toolbarActionSort': 'Ordenar',
	'toolbarActionSortAscending': 'Orden ascendente',
	'toolbarActionSortDescending': 'Orden descendente',
	'toolbarActionSortAuto': 'Automático (%{sortOrder})',
	'toolbarActionFormat': 'Formatear datos',
	'toolbarActionFormatAbbreviation': 'Abreviar',
	'toolbarActionFormatNone': 'Automático',
	'toolbarActionFilter': 'Filtro',
	'toolbarActionTopBottom': 'Parte superior o inferior',
	'toolbarActionAddShape': 'Añadir forma',
	'toolbarActionRmvShape': 'Eliminar forma',
	'toolbarActionToggleShapeDrop': 'Forma infográfica',
	'toolbarActionToggleShapeDropTitle': 'Crear un infográfico',
	'toolbarActionToggleShapeDropText': 'Arrastre una forma a este campo para crear un infográfico.',
	'toolbarActionAggregationType': 'Resumir',
	'toolbarDeleteActionText': 'Eliminar columna',
	'toolbarActionFilterLocalKeepSelected': 'Mantener',
	'toolbarActionFilterLocalExcludeSelected': 'Excluir',
	'toolbarActionFilterAllKeepSelected': 'Filtro',
	'toolbarActionSimpleCalculation': 'Cálculo simple',
	'toolbarActionDrillBack': 'Atrás',
	'toolbarActionDrillUp': 'Detallar menos',
	'toolbarActionDrillDown': 'Detallar más',
	'toolbarActionNavigate': 'Navegar',
	'toolbarActionCreateFilterGroup': 'Crear nueva conexión',
	'toolbarActionDisconnectFilterGroup': 'Romper todos los enlaces',
	'toolbarActionLinkFilterGroup': 'Añadir a una conexión existente',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Añadir',
	'sidebarMultiselect': 'Alternar selección múltiple',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} seleccionado ',

	'multiselectWithTotalMsg': '%{count} de %{total}',
	'sidebarGoBack': 'Retroceder',

	//DataSet pane
	'errorLoadingDataSets': 'No podemos cargar este conjunto de datos',
	'errorLoadingDataSetMetaData': 'No podemos cargar este conjunto de datos',
	'dataSetPaneLastUpdated': 'Última actualización: %{date}',
	'dataSetPaneDateUnknown': 'Desconocido',
	'sourcePaneLabel': 'Orígenes seleccionados',
	'addSourceLabel': 'Añadir un origen',
	'find_label': 'Buscar',
	'navigationPathsLabel': 'Rutas de navegación',

	//widgetlist
	'errorLoadingWidgetList': 'No podemos cargar los objetos.',
	'errorLoadingThemeFile': 'No podemos cargar la definición de tema',
	'errorLoadingLayoutFile': 'No podemos cargar la vista.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'No podemos cargar las definiciones de visualizaciones disponibles',

	'dwErrorLoadingVisualizationNotFound': 'No podemos cargar el objeto porque le falta una definición de visualización',
	'dwErrorLoadingVisualizationListNotFound': 'No podemos cargar la visualización.',
	'dwErrorRunningQuery': 'No se han podido recuperar los datos del conjunto de datos %{datasetName}.',
	'dwErrorGeoData': 'Han surgido problemas al mostrar los datos geográficos en un mapa. Elija otro tipo de visualización. ',
	'dwPromptSignonCancelWarning': 'Los datos para esta visualización no están disponibles. Proporcione los credenciales correctos.',
	'dwErrorMissingDataset': 'No podemos cargar la visualización porque el conjunto de datos asociado \'%{datasetName}\' no está disponible. ',
	'dwErrorRenderingVisualization': 'No podemos cargar esta visualización.',
	'dwErrorVisualizationTooSmall': 'La visualización es demasiado pequeña para mostrar los datos que contiene. Aumente el tamaño de la visualización o limite los datos que contiene.',
	'aria_label_datatable': 'Tabla de datos',
	'aria_key_navi_datatable_desc': 'Utilice las teclas de flecha para desplazarse a cada celda. Pulse las teclas Control e Inicio para ir a la primera fila y las teclas Control y Fin para ir a la última fila.',
	'geomapUnrecognizedLocations': 'Ubicaciones no reconocidas:',
	'geomapAmbiguousLocations': 'Regiones ambiguas:',

	// custom widget
	'customWidget': 'Widget personalizado',
	'customWidgetsTitle': 'Widgets personalizados',
	'noCustomWidgets': 'Sin widgets personalizados',

	// Action names
	'toggleContextBar': 'Alternar la barra de contexto',
	'delete': 'Suprimir',
	'share': 'Compartir',
	'unshare': 'Dejar de compartir',
	'rename': 'Cambiar nombre',
	'close': 'Cerrar',
	'duplicate': 'Duplicar',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Reintentar',

	'changeTemplate': 'Cambiar plantilla',

	// Aggregation Types
	'sum': 'Suma',
	'count': 'Recuento',
	'countdistinct': 'Recuento distinto',
	'avg': 'Promedio',
	'min': 'Mínimo',
	'max': 'Máximo',
	'custom': 'Personalizado',
	'calculated': 'Calculado',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% de modificación',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Criterios de visualización...',
	'QuickAddResultsHeader': 'Visualizaciones de datos',
	'NoQuickAddResults': 'No hay ninguna coincidencia con el propósito. ¿Desea crear un nuevo conjunto de datos?',
	'NoQuickAddResultsRetry': 'No hemos encontrado ninguna coincidencia. Vuelva a intentarlo con otros términos.',
	'templateWidgetTitle': 'Plantilla',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(en blanco)',

	'nullValueContent': '(ningún valor)',
	'nullValueText': 'Nulo',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Filtro de texto - %{columnName}',

	'textFilterSelectTab': 'Seleccionar',

	'textFilterConditionTab': 'Establecer una condición',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'No hay ningún elemento disponible.',

	'textFilterEquals': 'Igual a',
	'textFilterContains': 'Contiene',
	'textFilterBeginsWith': 'Empieza con',
	'textFilterEndsWith': 'Termina con',
	'textFilterDoesNotEqual': 'No es igual a',
	'textFilterDoesNotContain': 'No contiene',
	'textFilterDoesNotBeginWith': 'No comienza por',
	'textFilterDoesNotEndWith': 'No acaba por',
	'textFilterSampleText': 'Por ejemplo: A',

	'textFilterAndButton': 'Y',
	'textFilterOrButton': 'O',

	'dateFilterMessage': 'Seleccione un rango de fechas',
	'dateRangeControlRegionLabel': 'Filtro de rango de fechas - %{columnName}',
	'dateFilterRangeOption': 'Opción de rango',
	'dateFilterDateLabel': 'Fecha',
	'dateFilterBlank': '(en blanco)',
	'dateFilterBefore': 'Antes',
	'dateFilterAfter': 'Después',
	'dateFilterBetween': 'Entre',
	'dateFilterSampleText': 'DD-MM-AAAA',
	'dateTitle': 'Fecha',
	'dateIncludeBlankLabel': 'Incluir fecha en blanco',

	'timeTitle': 'Hora',
	'timeFilterMessage': 'Seleccione un rango de horas',
	'dateTimeFilterMessage': 'Seleccione un rango de fechas y horas',

	'topbottomNumberOfResultsLabel': 'Número de resultados',
	'topbottomPercentLabel': 'Porcentaje',
	'topbottomNumberOfResultsLimit': 'Entre %{lower}-%{higher}',
	'topbottomSelectOption': 'Opción de parte superior o inferior',
	'topbottomOptionLabel': 'Mostrar',
	'searchByLabel': 'Por',
	'searchNoMatches': 'No se han encontrado coincidencias',
	'topbottomRankColumnLabel': 'Añadir una columna de clasificación a la tabla',
	'topbottomNone': 'Ninguno',
	'topCount': 'Recuento superior',
	'topPercent': 'Mejor %',
	'bottomCount': 'Recuento inferior',
	'bottomPercent': 'Peor %',
	'topbottomSearchColumn': 'Buscar una columna',
	'searchColumnAriaLabel': 'Buscar una columna. Escriba el nombre de la columna en la que buscar y, a continuación, utilice la flecha hacia abajo para buscar la columna en una lista',
	'rankColumnLabel': 'Rango (%{columnLabel})',
	'topbottomClearLabel': 'Borrar',

	'rangeFilterControlRegionLabel': 'Filtro de rango - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Control del deslizador, utilice las flechas derecha e izquierda para mover los puntos de arrastre del deslizador',
	'sliderHandleLabel': 'Punto de arrastre del deslizador',
	'a11ySliderHandleLabel': 'Punto de arrastre del deslizador %{sliderValue}',
	'sliderInputLabel': 'valor',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Algunos elementos del conjunto de datos utilizados en esta visualización no están disponibles.',
	'datasetItemUnavailable': 'Este elemento del conjunto de datos no está disponible.',

	//Authoring topBottom
	'topOperator': 'Superior',
	'bottomOperator': 'Abajo',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} por %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Este objeto solamente',
	'deleteTopBottom': 'Suprimir recuento superior o inferior',
	'editTopBottom': 'Editar recuento superior o inferior',
	'deleteDrillState': 'Suprimir estado de obtención de detalles actual',
	'ariaDeleteDrillStateLabel': 'Pulse la tecla Intro para editar el recuento superior o inferior.',
	'drillUpStateTitle': 'Detallar menos',
	'drillDownStateTitle': 'Detallar más',
	'ariaEditTopBottomLabel': 'Pulse la tecla Intro para editar el recuento superior o inferior.',
	'ariaDeleteTopBottomLabel': 'Pulse la tecla DELETE (suprimir) para suprimir el recuento superior o inferior.',

	// Authoring filtering
	'dimFilterIn': 'Incluye: %{in}',
	'dimFilterNotIn': 'Excluye: %{out}',
	'measureFilterBetween': 'Entre %{lowerBound} y %{upperBound}',
	'measureFilterNotBetween': 'No entre %{lowerBound} y %{upperBound}',
	'gtFilter': 'Después de %{lowerBound}',
	'ltFilter': 'Antes de %{upperBound}',
	'notGtFilter': 'No después de %{lowerBound}',
	'notLtFilter': 'No antes de %{upperBound}',
	'localFilterTitle': 'Este objeto solamente',
	'globalFilterTitle': 'Todos los objetos',
	'deleteFilter': 'Suprimir filtro',
	'editFilter': 'Editar filtro',
	'ariaEditFilterLabel': 'Pulse la tecla INTRO para editar el filtro.',
	'ariaDeleteFilterLabel': 'Pulse la tecla SUPR para suprimir el filtro.',

	// Prompts
	'ariaEditPrompt': 'Pulse la tecla INTRO para cambiar el valor de solicitud',

	'moreDataIndicator': 'Sus datos se han recortado en %{threshold} elementos. Aplique el filtro para mostrar menos.',

	// data point filtering
	'dataPointFilterTitle': 'Puntos de datos',
	'dataPointFilterIncludeSummary': 'Incluidos %{valueCount} puntos de datos ',
	'dataPointFilterExcludeSummary': 'Excluidos %{valueCount} puntos de datos ',

	// DB2 connection page
	'db2Database': 'Base de datos DB2 (%{jdbcConnection})',
	'db2Title': 'Conectar a IBM DB2',

	// Database
	'databaseConnectionMessage': 'Proporcione los detalles de la conexión de base de datos:',
	'connectionString': 'Cadena de conexión a base de datos',
	'databaseCredentials': 'Credenciales: ',
	'databaseUserName': 'Nombre de usuario',
	'databasePassword': 'Contraseña',
	'databaseConnect': 'Conectar',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Escriba un término de búsqueda:',
	'twitterKeyword': 'Palabra clave',
	'twitterSearch': 'Buscar',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'No se ha podido crear la vista: %{error}\nOperación fallida: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtros de widget',
	'missingColumn': 'Falta: %{columnLabel}',
	'missingFiltering': 'Faltan filtros en los ID de columna siguientes:',
	'heatByLabel': 'Uso crítico por',
	'evColumns': 'Columnas',
	'evLocalFilters': 'Filtros locales',
	'evExpand': 'Expandir',
	'evFilterTooltip': 'Filtro',
	'evAdd': 'Añadir una columna',

	// Navigation View
	'navigationBack': 'Atrás',

	// Pinning
	'contentPinFail': 'No podemos recopilar el contenido. Vuelva a intentarlo más tarde.',
	'contentPinFailOld': 'No podemos anclar el contenido. Vuelva a intentarlo más tarde.',
	'pinRenameFail': 'No podemos cambiar el nombre de la chincheta. Vuelva a intentarlo más tarde.',

	// Layouts
	'dropZoneLabel': 'Soltar aquí para maximizar',

	//Share
	'shareDefaultPageTitle': 'Página %{index}',

	'nextPage': 'Página siguiente',
	'previousPage': 'Página anterior',

	'assetAssembly': 'vista',

	'toolbar_save': 'Guardar',
	'brgr_saveAs': 'Guardar como',
	'brgr_refresh': 'Renovar',

	// Save
	'saving': 'Guardando...',
	'save_success': 'La vista se ha guardado.',
	'save_failure': 'Lo lamentamos. La vista no se ha podido guardar. Vuelva a intentarlo más tarde.',
	'dashboard_save_success': 'Se ha guardado su panel de control.',

	'geminiLeave': 'Está a punto de salir de IBM Watson Analytics.',

	'warning': 'Aviso',
	'missingDataSetData': 'Los datos para este conjunto de datos no están disponibles. Renueve el conjunto de datos o póngase en contacto con el administrador para acceder al origen.',

	// Calculations
	'error_calculation_in_use': 'El cálculo seleccionado está siendo utilizado y no se puede suprimir.',

	'resize': 'Redimensionar',
	'rotate': 'Rotar',
	'moveHandle': 'Mover widget',
	'expandHandle': 'Expandir',
	'panHandle': 'Enfocar',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Navegar a',

	// Slide out titles
	'shapeSlideoutTitle': 'Formas',
	'textSlideoutTitle': 'Texto',
	'mediaSlideoutTitle': 'Soportes',
	'visualizationSlideoutTitle': 'Visualizaciones',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'El JSON proporcionado no es válido. Consulte el registro de errores para obtener más información.',

	// Widget type labels
	'shape_label': 'Forma',
	'image_label': 'Imagen',
	'data_label': 'Gráfico',
	'media_label': 'Soportes',
	'text_label': 'Texto',
	'embedMedia_label': 'Soportes',
	'youtube_label': 'Vídeo de YouTube',
	'webpage_label': 'Página web',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Forma',
	'noExtraText_shape_numbered': 'Forma (%{number})',
	'few_shape': 'Grupo de %{count} formas',
	'many_shape': 'Grupo de %{count} formas',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Imagen %{text}',
	'one_image_numbered': 'Imagen %{text} (%{number})',
	'noExtraText_image': 'Imagen',
	'noExtraText_image_numbered': '(%{number}) imagen',
	'few_image': 'Grupo de %{count} imágenes ',
	'many_image': 'Grupo de %{count} imágenes ',
	'noExtraText_text': 'Cuadro de texto vacío',
	'noExtraText_text_numbered': 'Cuadro de texto vacío (%{number})',
	'few_text': 'Grupo de %{count} cuadros de texto ',
	'many_text': 'Grupo de %{count} cuadros de texto ',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': 'Cube Viewer %{name} ',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': 'Tabla de referencias cruzadas %{values} por %{row_level1} y %{column_level1} ',
	'crosstab_opt_mapping_numbered': 'Tabla de referencias cruzadas %{values} por %{row_level1} y %{column_level1} (%{number})',
	'crosstab_has_mapping': 'Tabla de referencias cruzadas %{values} por %{row_level1} ',
	'crosstab_has_mapping_numbered': 'Tabla de referencias cruzadas %{values} por %{row_level1} (%{number}) ',
	'crosstab_no_mapping': 'Tabla de referencias cruzadas vacía',
	'crosstab_no_mapping_numbered': 'Tabla de referencias cruzadas vacía (%{number})',
	'crosstab_named': 'Tabla de referencias cruzadas %{name}',
	'crosstab_named_numbered': 'Tabla de referencias cruzadas %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': 'Tabla %{grid_cols} ',
	'JQGrid_has_mapping_numbered': 'Tabla %{grid_cols} (%{number})',
	'JQGrid_no_mapping': 'Tabla vacía',
	'JQGrid_no_mapping_numbered': 'Tabla vacía (%{number})',
	'JQGrid_named': 'Tabla %{name}',
	'JQGrid_named_numbered': 'Tabla %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Jerarquía %{level1}',
	'hierarchy_has_mapping_numbered': 'Jerarquía %{level1} (%{number})',
	'hierarchy_no_mapping': 'Jerarquía vacía',
	'hierarchy_no_mapping_numbered': 'Jerarquía vacía (%{number})',
	'hierarchy_named': 'Jerarquía %{name}',
	'hierarchy_named_numbered': 'Jerarquía %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Mapa %{categories}',
	'map_has_mapping_numbered': 'Mapa %{categories} (%{number})',
	'map_no_mapping': 'Mapa vacío',
	'map_no_mapping_numbered': 'Mapa vacío (%{number})',
	'map_named': 'Mapa %{name}',
	'map_named_numbered': 'Mapa %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Valor de resumen de %{actual}',
	'summary_has_mapping_numbered': 'Valor de resumen de %{actual} (%{number})',
	'summary_no_mapping': 'Valor de resumen vacío',
	'summary_no_mapping_numbered': 'Valor de resumen vacío (%{number})',
	'summary_named': 'Valor de resumen de %{name}',
	'summary_named_numbered': 'Valor de resumen de %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'KPI %{actual} por %{sparkline.time} ',
	'kpi_opt_mapping_numbered': 'KPI %{actual} por %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'KPI %{actual}',
	'kpi_has_mapping_numbered': 'KPI %{actual} (%{number})',
	'kpi_no_mapping': 'KPI vacío',
	'kpi_no_mapping_numbered': 'KPI vacío (%{number})',
	'kpi_named': 'KPI %{name}',
	'kpi_named_numbered': 'KPI %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Infográfico %{actual} ',
	'infographicSummary_has_mapping_numbered': 'Infográfico %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Infográfico vacío',
	'infographicSummary_no_mapping_numbered': 'Infográfico vacío (%{number})',
	'infographicSummary_named': 'Infográfico %{name} ',
	'infographicSummary_named_numbered': 'Infográfico %{name} (%{number})',
	'noExtraText_youtube': 'Vídeo de YouTube',
	'noExtraText_youtube_numbered': 'Vídeo de YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'Vídeo de YouTube %{text}',
	'one_youtube_numbered': 'Vídeo de YouTube %{text} (%{number})',
	'few_youtube': 'Grupo de %{count} vídeos de YouTube',
	'many_youtube': 'Grupo de %{count} vídeos de YouTube',
	'noExtraText_embedMedia': 'Enlace multimedia',
	'noExtraText_embedMedia_numbered': 'Enlace multimedia (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Enlace multimedia %{text} ',
	'one_embedMedia_numbered': 'Enlace multimedia %{text} (%{number})',
	'few_embedMedia': 'Grupo de %{count} enlaces multimedia',
	'many_embedMedia': 'Grupo de %{count} enlaces multimedia',
	'noExtraText_media': 'Multimedia',
	'noExtraText_media_numbered': 'Multimedia (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Multimedia %{text} ',
	'one_media_numbered': 'Multimedia %{text} (%{number})',
	'few_media': 'Grupo de %{count} multimedia',
	'many_media': 'Grupo de %{count} multimedia',
	'noExtraText_webpage': 'Página web',
	'noExtraText_webpage_numbered': 'Página web (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Página web %{text}',
	'one_webpage_numbered': 'Página web %{text} (%{number})',
	'few_webpage': 'Grupo de %{count} páginas web ',
	'many_webpage': 'Grupo de %{count} páginas web ',
	'one_unknown': 'Un objeto',
	'one_unknown_numbered': 'Un objeto (%{number})',
	'few_unknown': 'Grupo de %{count} objetos ',
	'many_unknown': 'Grupo de %{count} objetos ',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Siguiente',
	'previous': 'Anterior',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'El grupo de navegación actual es %{navigation_group_name}',

	//Page Context
	'filterBlank': '(en blanco)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Los valores de filtro no pueden cargarse',
	'editTimelineHighlight': 'Editar resaltado',

	'filterDockChevronLeft': 'Desplácese por los datos',
	'filterDockChevronRight': 'Desplácese por los datos',
	'expand': 'Expandir',
	'collapse': 'Contraer',

	//Reset Dashboard
	'dashboardResetTitle': 'Restablecer panel de control',
	'dashboardResetMessage': '¿Está seguro de que desea volver a establecer todos los cambios aplicados a este panel de control?',
	'dashboardResetToast': 'Se ha restablecido su panel de control.',

	//Generate PDF
	'buildingPDF': 'Creando PDF...',
	'exportPDF': 'Exportar a PDF',
	'pageSize': 'Tamaño de página',
	'orientation': 'Orientación',
	'filtersPresentPDF': 'Se han aplicado el o los filtros a la o las visualizaciones de la página anterior:',
	'errorPDF': 'No se puede generar el PDF. Renueve y vuelva a intentarlo.',
	'errorPrintPDF': 'No se puede generar el PDF. Vuelva a intentarlo.',
	'printPDFInfo': 'Ver documentación',
	'pdfWidget': 'Widget',
	'includeFilters': 'Visualizar detalles de filtro',
	'portrait': 'Vertical',
	'landscape': 'Horizontal',
	'letter': 'Carta',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloide',

	'toastUpgradeDone': 'Se ha actualizado su panel de control. Guarde ahora para mantener un rendimiento óptimo.',

	'migratingDashboard': 'Se deben migrar los datos del panel de instrumentos, se guardará el panel de instrumentos cuando se complete la migración...',
	'migrateDone': 'Se han migrado los datos del panel de instrumentos.',
	'migrateNoPermission': 'Se deben migrar los datos del panel de instrumentos; esto requiere permiso de escritura; las visualizaciones se representarán con error.',
	'migratingDataSourcesFailed': 'no se ha podido realizar la migración de datos de uno o varios orígenes de datos',

	'ariaFullScreenMessage': 'Pulse Esc para salir de la pantalla completa',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Gráfico de burbujas de jerarquías empaquetadas %{categories}',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Gráfico de burbujas de jerarquías empaquetadas %{categories} (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Gráfico de burbujas de jerarquías empaquetadas vacío',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Gráfico de burbujas de jerarquías empaquetadas vacío (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Gráfico de burbujas de jerarquías empaquetadas %{name}',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Gráfico de burbujas de jerarquías empaquetadas %{name} (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'Gráfico marimekko %{categories} por %{values} ',
	'LIVE_marimekko_has_mapping_numbered': 'Gráfico marimekko %{categories} por %{values} (%{number})',
	'LIVE_marimekko_no_mapping': 'Gráfico marimekko vacío',
	'LIVE_marimekko_no_mapping_numbered': 'Gráfico marimekko vacío (%{number})',
	'LIVE_marimekko_named': 'Gráfico marimekko %{name} ',
	'LIVE_marimekko_numbered': 'Gráfico marimekko %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Gráfico Sunburst %{values} ',
	'LIVE_sunburst_has_mapping_numbered': 'Gráfico Sunburst %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Gráfico Sunburst vacío',
	'LIVE_sunburst_no_mapping_numbered': 'Gráfico Sunburst vacío (%{number})',
	'LIVE_sunburst_named': 'Gráfico Sunburst %{name} ',
	'LIVE_sunburst_named_numbered': 'Gráfico Sunburst %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Gráfico de análisis de controladores %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Gráfico de análisis de controladores %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Gráfico de análisis de controladores vacío',
	'LIVE_decision_analysis_no_mapping_numbered': 'Gráfico de análisis de controladores vacío (%{number})',
	'LIVE_decision_analysis_named': 'Gráfico de análisis de controladores %{name}',
	'LIVE_decision_analysis_named_numbered': 'Gráfico de análisis de controladores %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': 'Gráfico de líneas y columnas %{categories} por %{columnValue} y %{lineValue}',
	'LIVE_line_column_opt_mapping_numbered': 'Gráfico de líneas y columnas {categories} por %{columnValue} y %{lineValue} (%{number})',
	'LIVE_line_column_has_mapping': ' Gráfico de líneas y columnas %{columnValue} y %{lineValue} ',
	'LIVE_line_column_has_mapping_numbered': 'Gráfico de líneas y columnas %{categories} por %{columnValue} y %{lineValue} (%{number})',
	'LIVE_line_column_no_mapping': 'Gráfico de líneas y columnas vacío',
	'LIVE_line_column_no_mapping_numbered': 'Gráfico de líneas y columnas vacío (%{number})',
	'LIVE_line_column_named': 'Gráfico de líneas y columnas %{name} ',
	'LIVE_line_column_named_numbered' : 'Gráfico de líneas y columnas %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': 'Gráfico de burbujas %{x} por %{y} y %{size} ',
	'LIVE_bubble_chart_has_mapping_numbered': 'Gráfico de burbujas %{x} por %{y} y %{size} (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Gráfico de burbujas vacío',
	'LIVE_bubble_chart_no_mapping_numbered': 'Gráfico de burbujas vacío (%{number})',
	'LIVE_bubble_chart_named': 'Gráfico de burbujas %{name} ',
	'LIVE_bubble_chart_named_numbered': 'Gráfico de burbujas %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Gráfico de viñetas %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Gráfico de viñetas %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Gráfico de viñetas vacío',
	'LIVE_bullet_no_mapping_numbered': 'Gráfico de viñetas vacío (%{number})',
	'LIVE_bullet_named': 'Gráfico de viñetas %{name}',
	'LIVE_bullet_named_numbered': 'Gráfico de viñetas %{name} (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'Los datos de este panel de control se proporcionan mediante',
	'showFooterToggleButtonText': 'Mostrar pie de página',
	'showFooterSectionText': 'Pie de página'

});
